import { parse } from 'next-useragent';

import { DeviceType } from '@/Module/Core/Model/Enum';

export const getDeviceTypeByUserAgent = (userAgentString: string) => {
  if (userAgentString === undefined || userAgentString === '' || userAgentString === 'undefined') return DeviceType.DESKTOP;

  const userAgent = parse(userAgentString);

  if (userAgent.isTablet || userAgent.isIpad) {
    return DeviceType.TABLET;
  }
  if (userAgent.isMobile) {
    return DeviceType.MOBILE;
  }

  return DeviceType.DESKTOP;
};
